// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"a3948a11","453":"a61b7447","865":"71f695be"}[chunkId] + ".chunk.js";
};